export function parsePercentage(): ((displayValue: string | undefined) => string) {
  return value => (value == null) ? "" : value.replace('%', '');
}

export const isNumeric = (value: string): boolean => {
  return /^\d+$/.test(value);
};
